import React, { createRef } from 'react';
import { DataGrid, Popup } from 'devextreme-react';
import DataSource, { DataSourceOptions } from 'devextreme/data/data_source';
import styles from './OrderEditScreenComponent.module.scss';
import { Box, Item } from 'devextreme-react/box';
import { FilterRow, Pager, Paging } from 'devextreme-react/data-grid';
import { RouteComponentProps } from 'react-router';
import { OrderEditScreenProps } from './OrderEditScreen';
import OrderEditForm, { OrderEditFormData } from '../../components/order-edit-form/OrderEditForm';
import { LoadPanel } from 'devextreme-react/load-panel';
import toast from 'fulogics-ui-web/dist/utils/toast';
import PayloadAddForm from '../../components/payload-add-form/PayloadAddForm';
import DonePopup from './done-popup/DonePopup';
import i18n from '../../../translations/i18n';
import { PATH_ORDERS } from '../../../constants/routerPaths';

interface OrderEditScreenComponentState {
    isLoading?: boolean;
    donePopupVisible?: boolean;
    //
    order?: OrderEditFormData;
}

const loadingPanelPosition = { of: '#containerRoot' };

export default class OrderEditScreenComponent extends React.Component<
    OrderEditScreenComponentProps,
    OrderEditScreenComponentState
> {
    constructor(props: OrderEditScreenComponentProps) {
        super(props);
        //
        this.state = {
            isLoading: true,
            donePopupVisible: false,
        };
        //
        //this.onFakeDone = this.onFakeDone.bind(this);
        this.onDone = this.onDone.bind(this);
        this.onDonePopupStatusChange = this.onDonePopupStatusChange.bind(this);
    }

    componentDidMount() {
        if (!this.props.acquireLock || !this.props.singleById) {
        } else {
            this.props
                .acquireLock?.({ id: this.props.orderId ?? '-1' })
                .then(() => {
                    this.props
                        .singleById?.(this.props.orderId)
                        .then((ro) => {
                            this.setState((currState) => ({
                                ...currState,
                                //
                                isLoading: false,
                                order: ro,
                            }));
                        })
                        .catch((error) => {
                            toast.exception(error);
                        });
                })
                .catch((error) => {
                    toast.exception(error);
                });
        }
    }

    /*async onFakeDone() {
        this.setState((currState) => ({
            ...currState,
            isLoading: true,
        }));
        //
        await this.props.fakeOrderSave?.(this.state.order?.id?.toString());
        //
        this.props.history.push(PATH_ORDERS);
    }*/

    async onDonePopupStatusChange() {
        await this.setState((p) => ({
            ...p,
            donePopupVisible: false,
        }));
    }

    async onDone() {
        this.setState((p) => ({
            ...p,
            isLoading: true,
        }));
        //
        this.props.history.push(PATH_ORDERS);
    }

    render() {
        return (
            <div id="containerRoot" className={styles.container}>
                <LoadPanel
                    position={loadingPanelPosition}
                    visible={this.state.isLoading}
                    shadingColor="rgba(0,0,0,0.4)"
                    showIndicator
                    shading
                    showPane
                    closeOnOutsideClick={false}
                />
                {this.state.donePopupVisible && (
                    <DonePopup
                        isVisible={this.state.donePopupVisible}
                        data={this.state.order}
                        onDone={this.onDone}
                        onDonePopupStatusChange={this.onDonePopupStatusChange}
                    />
                )}
                {!this.state.isLoading && (
                    <OrderEditForm
                        data={this.state.order}
                        //
                        doneButtonLabel={i18n.t('OrderEditScreenComponent:doneButtonLabel')}
                        onDone={async () =>
                            this.setState((prev) => ({
                                ...prev,
                                donePopupVisible: true,
                            }))
                        }
                    />
                )}
            </div>
        );
    }
}

type OrderEditScreenComponentProps = OrderEditScreenProps & RouteComponentProps<{}>;
